class SgcThreeImgSectionVar2Block {
  run() {
    // three-img-sec-2

    /* Scroll based triggering of animation */
    const options = {
      rootMargin: "0px",
      threshold: 1.0,
    };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        const img1 = $(entry.target).find(".img-container-1");
        const img2 = $(entry.target).find(".img-container-2");
        const img3 = $(entry.target).find(".img-container-3");

        if (entry.isIntersecting) {
          img1.addClass("animation-in");
          img2.addClass("animation-in");
          img3.addClass("animation-in");
        }

        /*
                const text = entry.target.innerText;

                entry.isIntersecting ?
                    animateCountUp(entry.target, text) :
                    entry.target.innerText = text; // make sure original number is shown
                */
      });
    }, options);

    $(".three-img-sec-2").each(function (index) {
      observer.observe(this);
    });
  }
}

module.exports = SgcThreeImgSectionVar2Block;
